import * as v from 'valibot';

const searchSchema = v.object({
  page: v.optional(v.fallback(v.number(), 1)),
  limit: v.optional(v.fallback(v.picklist([10, 20, 50]), 10)),
  sort: v.optional(v.string()),
  filter: v.optional(v.array(v.string())),
  search: v.optional(v.string()),
});

export function validateSearch(search: SearchSchemaInput) {
  return v.parse(searchSchema, search);
}

export type SearchSchemaInput = v.InferInput<typeof searchSchema>;
export type SearchSchemaOutput = v.InferOutput<typeof searchSchema>;
